import { atom, useRecoilState } from 'recoil';

const filtersState = atom({
  key: 'AudinDocumentsFilters',
  default: {
    createdAt: {
      start: null,
      end: null,
    },
    verbatim: '',
    type: '',
    step: ''
  },
});

const useFilters = () => {
  return useRecoilState(filtersState);
};

export default useFilters;